import { setCaptchaSolver } from '@shared-core/services/api'
import { AppLogger } from '@shared-core/services/logger'
import { useEffect } from 'react'
import { CAPTCHA_ENDPOINT } from './constants'

const logger = AppLogger.fork({ name: 'captcha' })

// Программный режим Cap: proof-of-work решается в воркерах без участия пользователя.
export function ServiceCaptcha() {
  // Солвер живёт, пока смонтирован сервис; без него запросы уходят без токена.
  useEffect(() => {
    setCaptchaSolver(async () => {
      const { default: Cap } = await import('cap-widget')
      const cap = new Cap({ apiEndpoint: CAPTCHA_ENDPOINT })

      try {
        const result = await cap.solve()

        if (result.success && result.token) return result.token
        logger.warn('Cap не выдал токен', result)
        return null
      } catch (error) {
        // Без лога запрос молча уходит без токена — причину (сеть, CORS, wasm) видно только здесь.
        logger.warn('Cap не решился', CAPTCHA_ENDPOINT, error)
        return null
      } finally {
        // Без элемента в конструкторе Cap добавляет скрытый виджет в документ — убираем за собой.
        cap.widget.remove()
      }
    })

    return () => setCaptchaSolver(null)
  }, [])

  return null
}
